<template>
  <b-modal
    v-model="showModal"
    :title="title"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('close')"
    scrollable
    no-close-on-backdrop
    size="lg"
  >
    <b-row class="modal-listado-trabajo-adicional">
      <b-col md="12" lg="12" xl="12">
        <b-table small responsive hover :items="items" :fields="fields">
          <template #cell(estado)="data">
            <b-badge
              :variant="getVariant(data.item.estado)"
              class="text-uppercase"
            >
              {{ data.item.estado }}
            </b-badge>
          </template>
          <template #cell(revisor)="data">
            <span v-if="data.item.estado !== 'pendiente'">
              {{ data.value }}
            </span>

            <span v-else> - </span>
          </template>
          <template #cell(created_at)="data">
            {{ data.item.created_at | myGlobalDay }}
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Fields from "@/views/rrhh/views/trabajo-adicional/data/tracking.field.data.js";
import { mapGetters } from "vuex";
import TrabajoAdicionalService from "@/views/rrhh/views/trabajo-adicional/services/trabajo.adicional.service.js";

export default {
  props: {
    id: {
      type: Number,
    },
  },
  data() {
    return {
      fields: Fields,
      showModal: true,
      items: [],
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    title() {
      return `Historial`;
    },
  },
  mounted() {
    this.getHistorialTrabajoAdicional();
  },
  methods: {
    async getHistorialTrabajoAdicional() {
      try {
        this.addPreloader();
        const params = {
          trabajo_adicional_id: this.id,
        };
        const { data } =
          await TrabajoAdicionalService.getHistorialTrabajoAdicional(params);

        console.log(data.data);
        this.items = data.data || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    getVariant(estado) {
      switch (estado) {
        case "pendiente":
          return "light-warning";
        case "aprobado":
          return "light-success";
        case "rechazado":
          return "light-danger";
        case "anulado":
          return "light-secondary";
        default:
          return "light-primary";
      }
    },
  },
};
</script>

<style lang="scss">
.modal-listado-trabajo-adicional {
  .custom-dark {
    background-color: #111113 !important;
  }

  .custom-light {
    background-color: #f8f9fa !important;
  }

  .card .card-title {
    margin-bottom: 0.5rem;
  }
}
</style>